// extracted by mini-css-extract-plugin
export default {"video_poster":"index_video_poster_j6MBa","miniVideo_poster":"index_miniVideo_poster_u54-K"};